import React from "react";
import datas from "../../data/product_data.json";
import Layout from "../Partials/Layout";

import HmLayout1 from "./HomeLayouts/HmLayout1";
import HmLayout2 from "./HomeLayouts/HmLayout2";
import HmLayout3 from "./HomeLayouts/HmLayout3";


// Which of the three (otherwise identical) widget orderings to show.
// `dash` only ever came from the old vendor login response — the
// passwordless myfit-api login (AuthPages/Login) has no equivalent value
// to set, so `layout` is now routinely missing, not just a theoretical
// edge case. Falls back to
// HmLayout1 instead of crashing (JSON.parse on a missing/garbled value,
// then reading `.dash` off of it) or rendering a blank page (an
// unrecognized code used to just render '').
const HOME_LAYOUT_BY_DASH_CODE = {
    33010: HmLayout1,
    33015: HmLayout2,
    33020: HmLayout3,
    33025: HmLayout1,
    33030: HmLayout3,
    33035: HmLayout2,
    33040: HmLayout1,
};

function getRecomendedDashLayout() {
    let mainLayout;
    try {
        mainLayout = JSON.parse(localStorage.getItem("layout"));
    } catch (error) {
        mainLayout = null;
    }
    const dash = mainLayout && mainLayout.dash;
    return HOME_LAYOUT_BY_DASH_CODE[dash] || HmLayout1;
}

export default function Home() {
    const trending = datas.datas;
    const DashLayout = getRecomendedDashLayout();
    return (
        <Layout>
            <div className="home-page-wrapper">
                <DashLayout />
            </div>
        </Layout>
    );
}
